// extracted by mini-css-extract-plugin
export default {"mapView":"mapView__8K0bV","embed":"embed__3rJfy"};